const schema = () => ({
  title: 'Image parallax',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'image',
        'image_alt',
        'height_desktop',
        'height_mobile',
        'focal_x',
        'focal_y',
      ],
    },
  ],
  properties: {
    image: {
      title: 'Image',
      type: 'string',
      widget: 'object_browser',
      mode: 'image',
    },
    image_alt: {
      title: 'Texte alternatif',
      type: 'string',
      description:
        "Laissez vide si l'image est purement decorative dans le rythme de la page.",
    },
    height_desktop: {
      title: 'Hauteur desktop (vh)',
      type: 'number',
      default: 60,
      description: 'Valeur entre 35 et 90.',
    },
    height_mobile: {
      title: 'Hauteur mobile (svh)',
      type: 'number',
      default: 42,
      description: 'Valeur entre 25 et 70.',
    },
    focal_x: {
      title: 'Cadrage horizontal (%)',
      type: 'number',
      default: 50,
      description: '0 = gauche, 50 = centre, 100 = droite.',
    },
    focal_y: {
      title: 'Cadrage vertical (%)',
      type: 'number',
      default: 50,
      description: '0 = haut, 50 = centre, 100 = bas.',
    },
  },
  required: ['image'],
});

export default schema;
